<template>
  <div class="card-wrapper">
    <div class="card mx-auto">
      <div class="circular-image">
        <img :src="`${publicPath}${service.imageCircular}`" :alt="service.imageCircular || service.alt">
      </div>
      <div class="card-body">
        <h5 class="card-title d-flex align-items-center justify-content-center">{{ service.title }}</h5>
        <p class="description" v-html="service.description"></p>
        <router-link class="d-flex justify-content-center" :to="serviceRoute" @click="handleClick">
          <button>{{ buttonText }} &nbsp;<i class="fa-solid fa-circle-chevron-right"></i></button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import json from '../../text.json'
import { serviceSlug } from '@/seo'

export default {
  name: 'ServiceCard',
  
  props: {
    service: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      default: 'En savoir plus'
    },
    enableAnimation: {
      type: Boolean,
      default: false
    },
    publicPath: {
      type: String,
      default: '/'
    }
  },

    data() {
    return {
      text: json,
    }
  },
  
  computed: {
    serviceRoute() {
      if (this.service.title === this.text.services.category[1].name) {
        return { name: 'services', hash: '#zootherapy' };
      }
      return {
        name: 'service',
        params: {
          serviceName: serviceSlug(this.service.title)
        }
      };
    }
  },
  
  methods: {
    handleClick() {
      this.$emit('card-click');
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/Style/utils/variables.scss';
@import '@/Style/utils/mixins.scss';

.card-wrapper {
  padding-top: 80px;
  margin-bottom: 20px;
}

.card {
  position: relative;
  padding-top: 20%;
  width: 100%;
}

.circular-image {
  position: absolute;
  top: -75px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  
  @include circular-image(150px, 5px);
}

.card-body {
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 1.5rem 1.5rem 1.5rem;
}
</style>
